module.exports = __webpack_public_path__ + "static/media/pdfDefault.2afde345.svg";